
export const sortPilots = (a,b) => (a && b ? (a.surname.localeCompare(b.surname)) : a.name.localeCompare(b.name));
